import { render, staticRenderFns } from "./PayrollMenu.vue?vue&type=template&id=1b4d45da&scoped=true"
import script from "./PayrollMenu.vue?vue&type=script&lang=js"
export * from "./PayrollMenu.vue?vue&type=script&lang=js"
import style0 from "./PayrollMenu.vue?vue&type=style&index=0&id=1b4d45da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4d45da",
  null
  
)

export default component.exports